/**
 * Created by zoechodosh on 2/17/17.
 */
export const REQUEST_USER = 'zola/user/REQUEST_USER';
export const RECEIVE_USER = 'zola/user/RECEIVE_USER';
export const IDENTIFY_USER = 'zola/user/IDENTIFY_USER';
export const IDENTIFY_GUEST_USER = 'zola/user/IDENTIFY_GUEST_USER';
